// Formateadores compartidos por el dashboard BI (escritorio) y la app BI (móvil).
import { toISOLocal } from './fecha'

// Importe abreviado para KPIs/ejes: $3.8 MM, $412 K, $1.250
export function fmtAbrev(n) {
  const num = Number(n) || 0
  const abs = Math.abs(num)
  const s = num < 0 ? '-' : ''
  if (abs >= 1e9) return `${s}$${(abs / 1e9).toLocaleString('en-US', { maximumFractionDigits: 2 })} MM`
  if (abs >= 1e6) return `${s}$${(abs / 1e6).toLocaleString('en-US', { maximumFractionDigits: 1 })} M`
  if (abs >= 1e3) return `${s}$${(abs / 1e3).toLocaleString('en-US', { maximumFractionDigits: 0 })} K`
  return `${s}$${abs.toLocaleString('en-US', { maximumFractionDigits: 0 })}`
}

export const fmtNum = (n) => (Number(n) || 0).toLocaleString('en-US', { maximumFractionDigits: 0 })

// Número completo: coma en miles, punto decimal, 2 decimales (ej. 1,234,567.89)
export const fmtMonto = (n) => (Number(n) || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

// Rampa categórica para series de datos (no son colores de UI).
export const PALETA_BI = ['#1d4ed8', '#6d28d9', '#0891b2', '#16a34a', '#ca8a04', '#dc2626', '#db2777', '#475569', '#0f766e', '#9333ea']

// Presets de rango de fecha compartidos
const iso = (d) => toISOLocal(d)
export function presetRangoBi(p) {
  const hoy = new Date()
  const y = hoy.getFullYear()
  switch (p) {
    case 'mes': return [iso(new Date(y, hoy.getMonth(), 1)), iso(hoy)]
    case 'mesAnterior': return [iso(new Date(y, hoy.getMonth() - 1, 1)), iso(new Date(y, hoy.getMonth(), 0))]
    case 'anio': return [iso(new Date(y, 0, 1)), iso(hoy)]
    case '12m': return [iso(new Date(y - 1, hoy.getMonth(), hoy.getDate())), iso(hoy)]
    case 'anioPasado': return [`${y - 1}-01-01`, `${y - 1}-12-31`]
    case 'todo': return ['2014-01-01', iso(hoy)]
    default: return [iso(new Date(y, 0, 1)), iso(hoy)]
  }
}
export const PRESETS_BI = [
  { k: 'mes', label: 'Este mes' },
  { k: 'mesAnterior', label: 'Mes anterior' },
  { k: 'anio', label: 'Este año' },
  { k: '12m', label: '12 meses' },
  { k: 'anioPasado', label: 'Año pasado' },
  { k: 'todo', label: 'Todo' },
]
